import React from 'react';
import './Line.css'

const Line = () => {
  return <div className="divider"></div>;
};

export default Line;